<div
  class="accordion-content-wrapper"
  [style.overflow]="overflow$ | async">
  <ng-content></ng-content>
</div>
